import { takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Auth
import { db } from "./../firebase";

function* handleDbSync(action) {
  const { role, uid } = action;

  //All

  //Watchers for all
  if (!role) {
    yield db.watchClientUsers(uid);
  }

  //Watchers for client
  if (role === "client") {
    yield db.watchClientUsers(uid);
  }

  //Watchers for user
  if (role === "user") {
    //
  }
}

export function* dbSync() {
  yield takeEvery(ACTIONS.DB_SYNC, handleDbSync);
}



// WEBPACK FOOTER //
// ./src/sagas/dbSync.js